export default __webpack_public_path__ + "locales/cs/Settings.json?hash=add6b539e7288d8e86d152a2fe9267d5";